import { observable, configure } from 'mobx';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

// Scheduled page-to-listings feeds for the marketplace (backend lib/marketplace-feed.js).
class MarketplaceFeedStore extends LocalModel {
    constructor() {
        super('marketplaceFeed', {
            namePlural: 'marketplaceFeeds',
            namePluralReal: 'marketplacefeeds',
            sort: '-createdDate',
            limit: 200,
            api: {
                search: {
                    url: '/api/marketplacefeeds/',
                    params: {
                        limit: 200,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/marketplacefeeds/',
                    params: {},
                },
                save: {
                    url: '/api/marketplacefeeds/',
                    params: {},
                },
                delete: {
                    url: '/api/marketplacefeeds/',
                    params: {},
                },
            },
        });
    }

    @observable marketplaceFeeds = [];

    @observable marketplaceFeed = {};

    @observable newMarketplaceFeed = {};

    @observable searchResults = [];

    @observable total = 0;

    @observable limit = 200;

    @observable offset = 0;

    @observable currentPage = 1;
}

const store = new MarketplaceFeedStore();
export default store;
